import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { useIdleTimer } from './hooks/useIdleTimer';

function App() {
  // Ref: GitHub issue #36, task S7 — logout after 30 min of inactivity
  useIdleTimer();
  return <RouterProvider router={router} />;
}

export default App;
